import AuthTokenResourceModel from '../../generated/types/model/resource/AuthTokenResourceModel';

export default class AuthTokenResourceViewModel extends AuthTokenResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
